// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"64400eee","94":"00f8884f","178":"b78f2b0f","364":"5bb8826a","470":"a838925b","488":"94fbb2b0","490":"ec3dd1db","511":"20261681","560":"f61ea6d9","611":"f82d245e","613":"8641dce7","738":"62f5c7e2","823":"26660248","927":"9e6fda59","965":"0534fe6c","967":"16d9a082"}[chunkId] + ".chunk.js";
};